export type NavItem = {label: string; href: string; description?: string};

export const PRODUCT_CATEGORIES_NAV: NavItem[] = [
  {
    label: 'Industrieller Schallschutz',
    href: '/produkt-kategorie/industrieller-schallschutz/',
    description: 'Schallschutz für Industrie und Maschinen',
  },
  {label: 'Raumakustik', href: '/produkt-kategorie/raumakustik/', description: 'Akustiklösungen für Räume'},
  {label: 'Lärmminderung', href: '/produkt-kategorie/laermminderung/', description: 'Weniger Lärm am Arbeitsplatz'},
];

export const MAIN_NAV: NavItem[] = [
  {label: 'Referenzen', href: '/referenzen/'},
  {label: 'Aktuelles', href: '/news/'},
  {label: 'Team', href: '/team/'},
];

export const LEGAL_NAV: NavItem[] = [
  {label: 'Impressum', href: '/impressum/'},
  {label: 'Datenschutz', href: '/datenschutz/'},
];

export const CONTACT = {
  company: 'Pernikl GmbH',
  claim: 'Akustik u. Schallschutztechnik',
  street: 'Rohnen 1080',
  city: '6861 Alberschwende',
  country: 'Österreich',
  phone: '+43 5579 20085-0',
  phoneHref: 'tel:+435579200850',
  mapsHref: 'https://www.google.com/maps/search/?api=1&query=Pernikl+GmbH+Rohnen+1080+6861+Alberschwende',
};
